import { z } from "zod";
import { adminPostLeadReqDtoSchema } from "service";
import {
  crmFieldValidations,
  requiredNameValidations,
} from "@/shared/utils/crm-validation";

// Feature-level refinement of the generated create-lead schema.
//
// The generated Zod schema (regenerated from the backend OpenAPI spec via
// `yarn generate:api`) is never hand-edited, so the frontend-only validation
// QA flagged lives here instead. We keep optionality aligned with the spec:
// optional fields stay optional, but when a value IS entered it must be valid.
export const leadFormSchema = adminPostLeadReqDtoSchema.extend({
  ...requiredNameValidations,
  address: z.string().min(1, "Service address is required"),
  ...crmFieldValidations,
});
